import type { NavigateFunction } from 'react-router-dom'

/** Open the Biddle detail modal via `?biddle=` + `?biddleProperty=` on the current path. */
export function openBiddleDetail(
  navigate: NavigateFunction,
  propertyId: string,
  biddleId: string,
  opts?: { pathname?: string; replace?: boolean },
) {
  const pathname = opts?.pathname ?? window.location.pathname
  const params = new URLSearchParams(
    pathname === window.location.pathname ? window.location.search : '',
  )
  // Don't stack over the property profile modal.
  params.delete('property')
  params.delete('create')
  params.set('biddle', biddleId)
  params.set('biddleProperty', propertyId)
  const search = `?${params.toString()}`
  navigate({ pathname, search }, { replace: opts?.replace })
}

export function closeBiddleDetail(navigate: NavigateFunction) {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('biddle') && !params.has('biddleProperty')) return
  params.delete('biddle')
  params.delete('biddleProperty')
  const search = params.toString() ? `?${params.toString()}` : ''
  navigate({ pathname: window.location.pathname, search }, { replace: true })
}
